<mat-spinner *ngIf="!isOrganisationsLoaded"></mat-spinner>

<div *ngIf="isOrganisationsLoaded && networks">

    <h1 *ngIf="this.header">{{globals.getLocalizedValueForTitle(this.header)}}</h1>

    <mat-card *ngIf="this.description" class="education-type-description">
        {{globals.getLocalizedValue(this.description)}}
    </mat-card>

    <mat-card *ngIf="educationType?.description?.valueFi || educationType?.description?.valueSv" class="education-type-description">
        <app-markdown [body]="globals.getLocalizedValueForTitle(educationType?.description)"></app-markdown>
    </mat-card>



    <div class="organisation-select">
        <mat-form-field>
        <mat-label *ngIf="this.select">{{globals.getLocalizedValue(this.select)}}</mat-label>
        <mat-select [(ngModel)]="selectedOrganisation" (selectionChange)="onOrganisationSelect($event)"  [disabled]="!isOrganisationsLoaded">
            <mat-option *ngFor="let organisation of sortedOrganisations " [value]="organisation.key" > 
                {{globals.getLocalizedValue(organisation.value)}}
            </mat-option>
        </mat-select>
        </mat-form-field>
    </div>



    <div class="organisation-content">
        <mat-spinner *ngIf="!isOrganisationsLoaded"></mat-spinner>
        <mat-accordion *ngIf="isOrganisationsLoaded">
            <mat-expansion-panel *ngFor="let network of networks; let j = index" (keydown)="collapse($event, j)" class="example-accordion-item" >
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="title">
                            <span>{{globals.getLocalizedValueIfAny(network.name)}}</span>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="network-group-body">
                    <table class="striped" *ngIf="network && network?.courses && network?.courses.length > 0">
                        <thead>
                            <tr>
                                <th>{{globals.getLocalizedValue(code)}}</th>
                                <th>{{globals.getLocalizedValue(name)}}</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let course of network.courses">
                                <td *ngIf="!period">
                                        <a routerLink="/{{globals.lang}}/{{globals.getLocalizedCourse()}}/{{course?.code}}/{{course?.id}}">{{course.code}}</a>
                                </td>
                                <td *ngIf="!period">
                                    <a routerLink="/{{globals.lang}}/{{globals.getLocalizedCourse()}}/{{course?.code}}/{{course?.id}}">{{globals.getLocalizedValueIfAny(course.name)}}</a>
                                </td>

                                <td *ngIf="period">
                                        <a routerLink="/{{globals.lang}}/{{globals.getLocalizedCourse()}}/{{course?.code}}/{{course?.id}}" [queryParams]="{period: period}">{{course.code}}</a>
                                </td>
                                <td *ngIf="period">
                                    <a routerLink="/{{globals.lang}}/{{globals.getLocalizedCourse()}}/{{course?.code}}/{{course?.id}}" [queryParams]="{period: period}">{{globals.getLocalizedValueIfAny(course.name)}}</a>
                                </td>               
                            </tr>
                        </tbody>
                    </table>   
                </div>   
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>